import { TwoFactorSetupRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/2fa_setup')({
  component: TwoFactorSetupRoute,
});
